import React from 'react';
import CarAssetListContainer from '../../containers/carmng/CarAssetListContainer';
const CarAssetListPage = () => {
  return (
    <CarAssetListContainer />
  );
};

export default CarAssetListPage;
